import * as React from "react";
import { ContextStore } from "../../../../../../../../react-core/Flux/Variables";
import { CommonHelper } from "../../../../../../../../react-core/Helpers/CommonHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../../react-core/Html/FormComponent";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { SelectEditor } from "../../../../../../../../react-core/Html/SelectEditor";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { DisinvestmentStrategyType } from "../../../../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { ContextType } from "../../../../../../../../Wrap/Constants/Enums/ContextType";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ChargeType } from "../../../../../../../../Wrap/Constants/Enums/ProductOverview/Charges/ChargeType";
import { ServiceProposition } from "../../../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { ServiceValidationError } from "../../../../../../../../Wrap/Core/DataTypes/ServiceValidation/ServiceValidationError";
import { AccountDisinvestmentStrategy } from "../../../../../../../../Wrap/Models/Domains/Account/AccountDisinvestmentStrategy";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { PortfolioManagerFee } from "../../../../../../../../Wrap/Models/Domains/ProductOverview/Charges/PortfolioManagerFee";
import { ProductCharge } from "../../../../../../../../Wrap/Models/Domains/ProductOverview/Charges/ProductCharge";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Navigator } from "../../../../../../../Shared/Wizards/Entities/Navigator";
import { Methods } from "../../../../../../Common/CommonHelper";
import { Urls } from "../../../../../../Urls";
import { DisinvestmentStrategyTypeArray } from "../../../../NewBusinessWizard/Resource/Contents";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { TransactionEnum } from "../../Transactions/Resource/Contents";
import { ProductOverviewChargeAction } from "../Action/ProductOverviewChargeAction";
import { DisinvestmentStrategyTypeMap, DisinvestmentTipMsg } from "../Constant/Content";
import { ProductOverviewChargeStore } from "../Stores/Variable";

export interface ChargesTableProps {
    subAccountHierarchyId?: string;
    selectedProduct?: SubAccountType;
    subClAccountId?: string;
    accountHierarchyId?: string;
}

interface IChargesTableState {
    data: ProductCharge;
    isLoading: boolean;
    showAccountDisinvestmentStrategy: boolean;
    accountDisinvestmentStrategy: DisinvestmentStrategyType;
    tempDisinvestmentStrategy: DisinvestmentStrategyType;
    clientAccount: ClientAccount;
}

export class ChargesTable extends FormComponent<ChargesTableProps, IChargesTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            data: null,
            isLoading: true,
            showAccountDisinvestmentStrategy: false,
            accountDisinvestmentStrategy: DisinvestmentStrategyType.NotSpecified,
            tempDisinvestmentStrategy: DisinvestmentStrategyType.NotSpecified,
            clientAccount: PortfolioDashboardStore.getData()?.find(
                (ele) => ele.HierarchyId == props.accountHierarchyId
            ),
        };
        this.subscribeToStore(ProductOverviewChargeStore, () => this.onNChargeStoreChange());
    }

    private onNChargeStoreChange() {
        const data = ProductOverviewChargeStore.getData();
        this.setState({
            data: data,
            isLoading: false,
        });
    }

    public componentDidMount() {
        this.getData();
        this.getAccountDisinvestmentStrategy();
    }

    public componentDidUpdate(prevProps: ChargesTableProps): void {
        if (prevProps.selectedProduct != this.props.selectedProduct) {
            this.getData();
        }
    }
    private getData() {
        const { subAccountHierarchyId } = this.props;
        this.setState({ isLoading: true });
        ProductOverviewChargeAction.getCharge(subAccountHierarchyId);
    }

    private getAccountDisinvestmentStrategy() {
        const { accountHierarchyId } = this.props;
        ProductOverviewChargeAction.getAccountDisinvestmentStrategy(
            accountHierarchyId,
            (res: AccountDisinvestmentStrategy) => {
                this.setState({ accountDisinvestmentStrategy: res.DisinvestmentStrategyType });
            }
        );
    }

    private getChargePercentageFormat(val?: number): string {
        const value = val ? val.toFixed(2) : 0;
        return value + "%";
    }

    private renderPortfolioManagerFeeDom(PortfolioManagerFees: Array<PortfolioManagerFee>): JSX.Element[] {
        if (PortfolioManagerFees && PortfolioManagerFees.length > 0) {
            const products: JSX.Element[] = [];
            PortfolioManagerFees.forEach((item, index) => {
                const product: JSX.Element = (
                    <tr key={index}>
                        <td className="cell-left">{item.PortfolioName}</td>
                        <td className="cell-right">
                            {this.getChargePercentageFormat(item.Percentage)} {" " + item.Frequency}
                        </td>
                    </tr>
                );
                products.push(product);
            });
            return products;
        } else {
            return null;
        }
    }

    private renderAccountDisinvestmentStrategyView() {
        return (
            <Lightbox
                show={this.state.showAccountDisinvestmentStrategy}
                title={"Auto-disinvestment strategy"}
                contentAfterTitle={null}
                onClose={() => {
                    this.setState({ showAccountDisinvestmentStrategy: false });
                }}
                type={LightboxType.Modal}
                cssWrapper="is-default-lightbox"
            >
                <div className="col-12 col-sm-fluid col-max-245">
                    <SelectEditor
                        key="DisinvestmentStrategyTypeOptions"
                        selected={this.state.accountDisinvestmentStrategy}
                        options={DisinvestmentStrategyTypeArray}
                        getText={(x) => DisinvestmentStrategyTypeMap[x]}
                        onChange={(val) => {
                            this.setState({ tempDisinvestmentStrategy: val });
                        }}
                    />
                </div>
                <div className="row">
                    <div className="col-auto">
                        <button
                            className="button mr-20"
                            onClick={(val) => this.setState({ showAccountDisinvestmentStrategy: false })}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="col-auto">
                        <button className="button" onClick={(val) => this.saveAccountDisinvestmentStrategy()}>
                            Save
                        </button>
                    </div>
                </div>
            </Lightbox>
        );
    }

    private saveAccountDisinvestmentStrategy() {
        ProductOverviewChargeAction.updateAccountDisinvestmentStrategy(
            {
                HierarchyId: this.props.accountHierarchyId,
                DisinvestmentStrategyType: this.state.tempDisinvestmentStrategy,
            },
            (callBack: Array<ServiceValidationError>) => {
                this.setState({
                    showAccountDisinvestmentStrategy: false,
                    accountDisinvestmentStrategy: this.state.tempDisinvestmentStrategy,
                });
            }
        );
    }

    private isLegacyProduct(selectedProduct: SubAccountType): boolean {
        return (
            selectedProduct == SubAccountType.OffshoreBond ||
            selectedProduct == SubAccountType.OnshoreBond ||
            selectedProduct == SubAccountType.Sipp
        );
    }

    public render(): JSX.Element {
        const { data, isLoading, clientAccount } = this.state;
        const { selectedProduct, subClAccountId } = this.props;
        if (isLoading) {return <PartLoading isLoading={true} />;}

        return (
            <>
                <div>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <h1 className="h2 mb-22">Charges</h1>
                            <div className="panel-subtle pt-0">
                                <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-15 row-higher">
                                    <tbody>
                                        <tr>
                                            <th scope="row">
                                                Platform charge
                                                <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                                                    {
                                                        "This value is based on the most recent Platform Charge event. The next Platform charge amount may be vary from this value."
                                                    }
                                                </AriaTooltip>
                                            </th>
                                            <td className="cell-right">
                                                {this.getChargePercentageFormat(data?.PlatformChargePercentage)}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">Next ongoing adviser charge due</th>
                                            <td className="cell-right">
                                                {data?.OngoingAdviserCharge != null
                                                    ? JsonDateParser.getFormatDate(
                                                          data?.OngoingAdviserCharge?.NextPaymentDate,
                                                          "dd/MM/yyyy"
                                                      )
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th scope="row">
                                                Ongoing adviser charge
                                                {checkPermission(UserClaim.AdviserPortalDluAdviserChargingCanView) && (
                                                    <a
                                                        type="button"
                                                        title="Edit"
                                                        className="edit-circle-icon-button ml-5 label-sr-only"
                                                        href={
                                                            "/clients/fees/AdviserCharging/AdviserCharging.aspx?claccountid=" +
                                                            subClAccountId
                                                        }
                                                    >
                                                        <span className="icon"></span>
                                                        <span className="sr-only">Edit ongoing adviser charge</span>
                                                    </a>
                                                )}
                                            </th>
                                            <td className="cell-right">
                                                {data?.OngoingAdviserCharge != null
                                                    ? (data?.OngoingAdviserCharge?.ChargeType == ChargeType.Percentage
                                                          ? this.getChargePercentageFormat(
                                                                data?.OngoingAdviserCharge?.Value
                                                            )
                                                          : Methods.getMoneyFormat(
                                                                {
                                                                    Amount: data?.OngoingAdviserCharge?.Value,
                                                                    Currency: CurrencyCode.GBP,
                                                                },
                                                                true
                                                            )) +
                                                      (" " + data?.OngoingAdviserCharge?.Frequency)
                                                    : "N/A"}
                                            </td>
                                        </tr>
                                        {data?.ProductAdministrationChargePercentage != null &&
                                            this.isLegacyProduct(selectedProduct) && (
                                                <tr>
                                                    <th scope="row">Product administration charge</th>
                                                    <td className="cell-right">
                                                        {this.getChargePercentageFormat(
                                                            data?.ProductAdministrationChargePercentage
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                                <Permission userClaim={UserClaim.AdviserPortalPerformanceChargesCanView}>
                                    <div>
                                        <button
                                            className="hyperlink"
                                            onClick={() =>
                                                Navigator.navigateTo(
                                                    Urls.get().main.PortfolioDashboard({
                                                        hierarchyId: ContextStore.getUrlParamsHierarchyId(
                                                            ContextType.Customer
                                                        ),
                                                    }).transactions,
                                                    {
                                                        scrollAfterNavigating: true,
                                                        queryParamsObject: {
                                                            transtypeselect: TransactionEnum.charges,
                                                            hierarchyid: this.props.subAccountHierarchyId,
                                                        },
                                                    }
                                                )
                                            }
                                        >
                                            View charges
                                        </button>
                                    </div>
                                </Permission>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6">
                            {data?.PortfolioManagerFees.length > 0 && (
                                <>
                                    <h1 className="h2 mb-22">Portfolio manager fee</h1>
                                    <div className="panel-subtle row-higher">
                                        <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-15">
                                            <thead>
                                                <tr>
                                                    <th className="cell-left">Portfolio name</th>
                                                    <th className="cell-right">Portfolio fee</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.renderPortfolioManagerFeeDom(data?.PortfolioManagerFees)}
                                            </tbody>
                                        </table>
                                    </div>
                                </>
                            )}

                            {clientAccount?.AccountServicePropositionId == ServiceProposition.Wrap &&
                                clientAccount?.Company != "SAVINGSDIRECT" &&
                                !this.isLegacyProduct(selectedProduct) && (
                                    <>
                                        <h2 className="h2 mb-22">
                                            Auto-Disinvestment strategy
                                            <AriaTooltip cssWrapper="is-info-icon ml-5" showCloseButton={true}>
                                                {DisinvestmentTipMsg}
                                            </AriaTooltip>
                                        </h2>
                                        <div className="panel-subtle">
                                            <table className="table-subtle table-first-last-cell-padding-reset has-first-cell-highlighted mb-15">
                                                <tr>
                                                    <th scope="row">
                                                        Strategy
                                                        <button
                                                            type="button"
                                                            title="Edit"
                                                            disabled={
                                                                !checkPermission(
                                                                    UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite
                                                                )
                                                            }
                                                            className="edit-circle-icon-button ml-5 label-sr-only"
                                                            onClick={() =>
                                                                this.setState({
                                                                    showAccountDisinvestmentStrategy: true,
                                                                })
                                                            }
                                                        >
                                                            <span className="icon"></span>
                                                            <span className="sr-only">
                                                                Edit account disinvestment strategy
                                                            </span>
                                                        </button>
                                                    </th>
                                                    <td className="cell-right">
                                                        {
                                                            DisinvestmentStrategyTypeMap[
                                                                this.state.accountDisinvestmentStrategy
                                                            ]
                                                        }
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </>
                                )}
                        </div>
                    </div>
                </div>
                {this.state.showAccountDisinvestmentStrategy && this.renderAccountDisinvestmentStrategyView()}
            </>
        );
    }
}
